"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_MENU_NAMES = exports.REVIEWS = exports.MICROACTIONS_ROLES = exports.MULTI_ADMIN = exports.SUPER_ADMIN = exports.ADMIN = exports.USER = void 0;
exports.USER = 'user';
exports.ADMIN = 'admin';
exports.SUPER_ADMIN = 'super-admin';
exports.MULTI_ADMIN = 'multi-admin';
exports.MICROACTIONS_ROLES = [exports.USER, exports.ADMIN, exports.SUPER_ADMIN, exports.MULTI_ADMIN];
exports.REVIEWS = 'reviews';
exports.ROLE_MENU_NAMES = {
    [exports.USER]: 'USER DASHBOARD',
    [exports.ADMIN]: 'ADMIN PANEL',
    [exports.SUPER_ADMIN]: 'SUPER ADMIN PANEL',
    [exports.MULTI_ADMIN]: 'MULTI ADMIN PANEL',
};
//# sourceMappingURL=roles.js.map